export default "__VITE_ASSET__cf4609b1__$_?nuxt_component=async&nuxt_component_name=SvgoMap__"